export default function validate(input) {
    const errors = {};

    // Base Price
    if (!input.basePrc || isNaN(input.basePrc) || Number(input.basePrc) < 0) {
        errors.basePrc = "Base price is required and must be a positive number";
    }

    // Payment Type
    if (!input.custPayType) {
        errors.custPayType = "Payment type is required";
    }

    // Advance
    // if (input.custPayType === "advance") {
    //     if (!input.advance || isNaN(input.advance) || Number(input.advance) < 0) {
    //         errors.advance = "Advance amount must be a valid number ≥ 0";
    //     }
    // }

    // BreakUp validations
    input.breakUp.forEach((item, index) => {
        if (!item.breakup_type) {
            errors[`breakup_type_${index}`] = "Breakup type is required";
        }
        if (!item.breakup_detail) {
            errors[`breakup_detail_${index}`] = "Breakup detail is required";
        }
        if (item.breakup_amt === "" || item.breakup_amt == null || isNaN(item.breakup_amt) || Number(item.breakup_amt) < 0) {
            errors[`breakup_amt_${index}`] = "Breakup amount must be a valid number ≥ 0";
        }
        // if (!item.breakup_free_txt) {
        //     errors[`breakup_free_txt_${index}`] = "Breakup detail is required";
        // }
    });

    return errors;
}
